import { produce as p } from "immer";
import { create as $ } from "zustand";
import { devtools as h } from "zustand/middleware";
import "react/jsx-runtime";
import "react";
import "@sentry/react";
import "./index.es4.js";
import "./index.es20.js";
import "@tanstack/react-query";
import "qs";
import "@turf/turf";
import "./index.es175.js";
import "./index.es176.js";
import "./index.es46.js";
import "./index.es6.js";
import "./index.es99.js";
import "@placer-ui/components";
import "./index.es203.js";
import "./index.es204.js";
import "./index.es205.js";
import "./index.es206.js";
import "use-debounce";
import "@deck.gl/geo-layers/typed";
import "@deck.gl/core/typed";
import "@deck.gl/layers/typed";
import "./index.es82.js";
import "./index.es113.js";
import "@deck.gl/extensions/typed";
import "./index.es59.js";
import "kdbush";
import "geobuckets";
import "react-map-gl";
import "./index.es208.js";
import "./index.es230.js";
import "./index.es231.js";
import "./index.es232.js";
import "./index.es233.js";
import "./index.es234.js";
import "./index.es131.js";
import "./index.es166.js";
import "@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css";
import "./index.es235.js";
import "classnames";
import "./index.es236.js";
import "./index.es137.js";
import "./index.es138.js";
import "react-dom";
import "./index.es210.js";
import "@deck.gl/mapbox/typed";
import "./index.es211.js";
import "./index.es212.js";
import "./index.es213.js";
import "mapbox-gl";
import "fabric";
import "./index.es170.js";
import "lodash/fp";
import "lodash/throttle";
import "lodash/debounce";
import "queue";
import "./index.es214.js";
import "./index.es90.js";
import "./index.es215.js";
import "./index.es216.js";
import "./index.es217.js";
import "./index.es23.js";
import "./index.es18.js";
import "./index.es179.js";
import "./index.es218.js";
import "./index.es219.js";
import "./index.es158.js";
import "lodash";
import "./index.es220.js";
import "./index.es221.js";
import "./index.es222.js";
import "./index.es223.js";
import "./index.es224.js";
import "@placer-ui/hooks";
import "./index.es225.js";
import "./index.es226.js";
import "./index.es227.js";
import "./index.es237.js";
import "./index.es238.js";
import "./index.es143.js";
import "./index.es239.js";
import "./index.es84.js";
import "./index.es78.js";
import "./index.es80.js";
import "@deck.gl/aggregation-layers/typed";
import "./index.es86.js";
import "./index.es74.js";
import "./index.es207.js";
import "./index.es72.js";
import { defaultTextboxConfig as k } from "./index.es101.js";
import "./index.es209.js";
import "./index.es103.js";
import "./index.es35.js";
import "./index.es36.js";
import "./index.es45.js";
import "./index.es39.js";
import "./index.es40.js";
import "zustand/react/shallow";
import "./index.es43.js";
import "@loaders.gl/core";
import "@loaders.gl/mvt";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es228.js";
import "./index.es229.js";
import D from "./index.es240.js";
const Mi = $()(
  h(
    (a, L) => ({
      maps: {},
      actions: {
        initMapStore: ({ mapId: e }) => {
          const i = L().maps;
          if (i && i[e]) {
            console.warn(
              `Map ID: ${e} already exists within the usePLMapboxLayersStore`
            );
            return;
          }
          a(
            p((o) => {
              o.maps[e] = {
                layerGroupConfig: {},
                combinedLayersStatus: {},
                combinedLayersData: {},
                layersData: {},
                backedUpLayerGroupConfig: {},
                combinedLayerSelection: {},
                selectedFeature: {
                  layerId: void 0,
                  feature: void 0
                },
                lastUpdatedStyle: {
                  textbox: k
                },
                subLayerIdToLayerGroupId: {}
              };
            }),
            !1,
            `initMapStore - ${e}`
          );
        },
        deleteMapStore: (e) => {
          a(
            p((i) => {
              delete i.maps[e];
            }),
            !1,
            `deleteMapStore - ${e}`
          );
        },
        resetMapStore: ({ mapId: e }) => {
          a(
            p((i) => {
              i.maps[e] = {
                layerGroupConfig: {},
                combinedLayersStatus: {},
                combinedLayersData: {},
                layersData: {},
                backedUpLayerGroupConfig: {},
                combinedLayerSelection: {},
                lastUpdatedStyle: {
                  textbox: k
                },
                subLayerIdToLayerGroupId: {}
              };
            }),
            !1,
            `resetMapStore - ${e}`
          );
        },
        isMapStoreLoaded: (e) => {
          var o;
          return !!((o = L().maps) == null ? void 0 : o[e]);
        },
        addLayerGroup: ({ mapId: e, groupLayerId: i, ...o }) => {
          const { renderType: s } = o, t = i ?? `group-${s}-${D()}`;
          return a(
            p((r) => {
              r.maps[e].layerGroupConfig[t] = o, r.maps[e].combinedLayersStatus[t] = "init";
            }),
            !1,
            `addLayerGroup - ${t}`
          ), t;
        },
        addSubLayer: ({ mapId: e, layerGroupId: i, subLayerConfig: o }) => {
          const { renderType: s } = o, t = `sub-${s}-${D()}`;
          return a(
            p((r) => {
              r.maps[e].layerGroupConfig[i].subLayerConfig[t] = o, r.maps[e].combinedLayersStatus[t] = "init", r.maps[e].subLayerIdToLayerGroupId[t] = i;
            }),
            !1,
            `addSubLayer - ${t}`
          ), t;
        },
        updateLayerGroup: ({
          mapId: e,
          layerGroupId: i,
          name: o,
          visible: s,
          description: t,
          layerColor: r,
          fetchFilter: n,
          layerGradient: m,
          visualFilter: u,
          poiCalloutBoxConfig: g,
          textboxStyleConfig: y,
          populationStatsConfig: c,
          marketsStatsConfig: f
        }) => {
          a(
            p((l) => {
              var b;
              o && (l.maps[e].layerGroupConfig[i].name = o), typeof s == "boolean" && (l.maps[e].layerGroupConfig[i].visible = s), t && (l.maps[e].layerGroupConfig[i].description = t), r && (l.maps[e].layerGroupConfig[i].layerColor = r), m && (l.maps[e].layerGroupConfig[i].layerGradient = m), n && (l.maps[e].layerGroupConfig[i].fetchFilter = {
                ...l.maps[e].layerGroupConfig[i].fetchFilter,
                ...n
              }), u && (l.maps[e].layerGroupConfig[i].visualFilter = {
                ...l.maps[e].layerGroupConfig[i].visualFilter,
                ...u
              }), g && (l.maps[e].layerGroupConfig[i].visualFilter = {
                ...l.maps[e].layerGroupConfig[i].visualFilter,
                poiCalloutBoxConfig: {
                  ...(b = l.maps[e].layerGroupConfig[i].visualFilter) == null ? void 0 : b.poiCalloutBoxConfig,
                  ...g
                }
              }), y && (l.maps[e].layerGroupConfig[i].visualFilter.textboxStyleConfig = {
                ...l.maps[e].layerGroupConfig[i].visualFilter.textboxStyleConfig,
                ...y
              }), c && (l.maps[e].layerGroupConfig[i].fetchFilter.populationStatsConfig = {
                ...l.maps[e].layerGroupConfig[i].fetchFilter.populationStatsConfig,
                ...c
              }), f && (l.maps[e].layerGroupConfig[i].fetchFilter.marketsStatsConfig = {
                ...l.maps[e].layerGroupConfig[i].fetchFilter.marketsStatsConfig,
                ...f
              });
            }),
            !1,
            `updateLayerGroup - ${i}`
          );
        },
        updateLayerGroupFull: ({
          mapId: e,
          layerGroupId: i,
          name: o,
          visible: s,
          description: t,
          layerColor: r,
          fetchFilter: n,
          layerGradient: m,
          visualFilter: u,
          poiCalloutBoxConfig: g,
          textboxStyleConfig: y,
          populationStatsConfig: c
        }) => {
          a(
            p((f) => {
              o && (f.maps[e].layerGroupConfig[i].name = o), typeof s == "boolean" && (f.maps[e].layerGroupConfig[i].visible = s), t && (f.maps[e].layerGroupConfig[i].description = t), r && (f.maps[e].layerGroupConfig[i].layerColor = r), m && (f.maps[e].layerGroupConfig[i].layerGradient = m), n && (f.maps[e].layerGroupConfig[i].fetchFilter = n), u && (f.maps[e].layerGroupConfig[i].visualFilter = u), g && (f.maps[e].layerGroupConfig[i].visualFilter.poiCalloutBoxConfig = g), y && (f.maps[e].layerGroupConfig[i].visualFilter.textboxStyleConfig = y), c && (f.maps[e].layerGroupConfig[i].fetchFilter.populationStatsConfig = c);
            }),
            !1,
            `updateLayerGroupFull - ${i}`
          );
        },
        updateSubLayer: ({
          mapId: e,
          layerGroupId: i,
          subLayerId: o,
          name: s,
          visible: t,
          description: r,
          layerColor: n,
          layerGradient: m,
          fetchFilter: u,
          visualFilter: g,
          renderType: y,
          poiCalloutBoxConfig: c,
          populationStatsConfig: f,
          marketsStatsConfig: l
        }) => {
          var S, G, F, v;
          const b = L().maps;
          (v = (F = (G = (S = b == null ? void 0 : b[e]) == null ? void 0 : S.layerGroupConfig) == null ? void 0 : G[i]) == null ? void 0 : F.subLayerConfig) != null && v[o] && a(
            p((C) => {
              s && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].name = s), typeof t == "boolean" && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].visible = t), r && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].description = r), n && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].layerColor = n), m && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].layerGradient = m), u && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter = {
                ...C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter,
                ...u
              }), y && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].renderType = y), g && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].visualFilter = {
                ...C.maps[e].layerGroupConfig[i].subLayerConfig[o].visualFilter,
                ...g
              }), c && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].visualFilter.poiCalloutBoxConfig = {
                ...C.maps[e].layerGroupConfig[i].subLayerConfig[o].visualFilter.poiCalloutBoxConfig,
                ...c
              }), f && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter.populationStatsConfig = {
                ...C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter.populationStatsConfig,
                ...f
              }), l && (C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter.marketsStatsConfig = {
                ...C.maps[e].layerGroupConfig[i].subLayerConfig[o].fetchFilter.marketsStatsConfig,
                ...l
              });
            }),
            !1,
            `updateSubLayer - ${i}`
          );
        },
        updateOffsetGroupMap: ({ mapId: e, layerGroupId: i, subLayerId: o, poiId: s, position: t }) => {
          a(
            p((r) => {
              o ? r.maps[e].layerGroupConfig[i].subLayerConfig[o].visualFilter.offsetMap[s] = t : r.maps[e].layerGroupConfig[i].visualFilter.offsetMap[s] = t;
            }),
            !1,
            `updateOffsetGroupMap - ${e}, ${i},
                            ${o}, ${s}`
          );
        },
        setCombinedLayersData: ({ mapId: e, layerId: i, data: o, status: s = "loaded" }) => {
          a(
            p((t) => {
              t.maps[e].combinedLayersData[i] = o, t.maps[e].combinedLayersStatus[i] = s;
            }),
            !1,
            `setCombinedLayersData - ${i}`
          );
        },
        setLayersData: ({ mapId: e, layerId: i, dataKey: o, data: s, isLoading: t }) => {
          a(
            p((r) => {
              r.maps[e].layersData[i] || (r.maps[e].layersData[i] = {}), r.maps[e].layersData[i][o] || (r.maps[e].layersData[i][o] = {
                data: void 0,
                isLoading: !1
              }), r.maps[e].layersData[i][o].data = s, r.maps[e].layersData[i][o].isLoading = !!t;
            }),
            !1,
            `setLayersData - ${i}`
          );
        },
        setAdHocData: ({ mapId: e, dataKey: i, data: o }) => {
          a(
            p((s) => {
              s.maps[e].adHocData || (s.maps[e].adHocData = {}), s.maps[e].adHocData[i] = o;
            }),
            !1,
            `setAdHocData - ${i}`
          );
        },
        setSelectedFeature: ({ mapId: e, layerId: i, feature: o }) => {
          a(
            p((s) => {
              s.maps[e].selectedFeature = {
                layerId: i,
                feature: o
              };
            }),
            !1,
            "setSelectedFeature"
          );
        },
        clearSelectedFeature: ({ mapId: e }) => {
          a(
            p((i) => {
              i.maps[e].selectedFeature = {
                layerId: void 0,
                feature: void 0
              };
            }),
            !1,
            "clearSelectedFeature"
          );
        },
        setCombinedLayersStatus: ({ mapId: e, layerId: i, status: o }) => {
          a(
            p((s) => {
              s.maps[e].combinedLayersStatus[i] = o;
            }),
            !1,
            `setCombinedLayersStatus - ${i}`
          );
        },
        toggleLayerGroup: ({ mapId: e, layerGroupId: i }) => {
          a(
            p((o) => {
              var n;
              const s = o.maps[e].layerGroupConfig[i], t = !s.visible;
              s.visible = t, Object.keys(s.subLayerConfig).forEach((m) => {
                const u = s.subLayerConfig[m];
                u.visible = t;
                const g = u.visualFilter.items;
                if (g == null ? void 0 : g.length) {
                  const c = [...g].map((f) => ({
                    ...f,
                    visible: t
                  }));
                  u.visualFilter.items = c;
                }
              });
              const r = (n = s.visualFilter) == null ? void 0 : n.items;
              r != null && r.length && (s.visualFilter.items = [...r].map(
                (m) => ({
                  ...m,
                  visible: t
                })
              ));
            }),
            !1,
            `toggleLayerGroup - ${i}`
          );
        },
        toggleSubLayer: ({ mapId: e, layerGroupId: i, subLayerId: o }) => {
          a(
            p((s) => {
              const t = s.maps[e].layerGroupConfig[i].subLayerConfig[o], r = !t.visible;
              t.visible = r;
              const n = t.visualFilter.items;
              if (n == null ? void 0 : n.length) {
                const g = [...n].map((y) => ({
                  ...y,
                  visible: r
                }));
                t.visualFilter.items = g;
              }
              Object.entries(
                s.maps[e].layerGroupConfig[i].subLayerConfig
              ).some(([g, y]) => y.visible) && (s.maps[e].layerGroupConfig[i].visible = !0), Object.keys(
                s.maps[e].layerGroupConfig[i].subLayerConfig
              ).length === 1 && s.maps[e].layerGroupConfig[i].renderType !== "tags" && (s.maps[e].layerGroupConfig[i].visible = r);
            }),
            !1,
            `toggleSubLayer - ${o}`
          );
        },
        deleteLayerGroup: ({ mapId: e, layerGroupId: i }) => {
          a(
            p((o) => {
              var t;
              Object.keys(
                ((t = o.maps[e].layerGroupConfig[i]) == null ? void 0 : t.subLayerConfig) || {}
              ).forEach((r) => {
                delete o.maps[e].combinedLayersData[r], delete o.maps[e].combinedLayersStatus[r];
              }), delete o.maps[e].layerGroupConfig[i], delete o.maps[e].combinedLayersData[i], delete o.maps[e].combinedLayersStatus[i], delete o.maps[e].layersData[i];
            }),
            !1,
            `deleteLayerGroup-${i}`
          );
        },
        deleteSubLayer: ({ mapId: e, layerGroupId: i, subLayerId: o }) => {
          a(
            p((s) => {
              delete s.maps[e].layerGroupConfig[i].subLayerConfig[o], delete s.maps[e].combinedLayersData[o], delete s.maps[e].combinedLayersStatus[o], delete s.maps[e].subLayerIdToLayerGroupId[o], Object.keys(
                s.maps[e].layerGroupConfig[i].subLayerConfig
              ).length === 0 && s.maps[e].layerGroupConfig[i].renderType !== "tags" && (delete s.maps[e].layerGroupConfig[i], delete s.maps[e].combinedLayersData[i], delete s.maps[e].combinedLayersStatus[i]);
            }),
            !1,
            `deleteSubLayer-${o}`
          );
        },
        setLayerGroupConfig: ({ mapId: e, layerGroupConfig: i }) => {
          a(
            p((o) => {
              o.maps[e].layerGroupConfig = i;
            }),
            !1,
            "setLayerGroupConfig"
          );
        },
        setCombinedLayerSelection: ({ mapId: e, layerId: i, features: o }) => {
          a(
            p((s) => {
              s.maps[e].combinedLayerSelection[i] = o || {};
            }),
            !1,
            `setCombinedLayerSelection - ${i}`
          );
        },
        setLastUpdatedStyle: ({ mapId: e, renderType: i, lastUpdatedStyle: o }) => {
          a(
            p((s) => {
              s.maps[e].lastUpdatedStyle = {
                ...s.maps[e].lastUpdatedStyle,
                [i]: {
                  ...o
                }
              };
            }),
            !1,
            `setLastUpdatedStyle - ${i}`
          );
        },
        clearCombinedLayerSelection: ({ mapId: e }) => {
          a(
            p((i) => {
              i.maps[e].combinedLayerSelection = {};
            }),
            !1,
            "clearCombinedLayerSelection"
          );
        },
        backupLayers: ({ mapId: e }) => {
          a(
            p((i) => {
              i.maps[e].backedUpLayerGroupConfig = i.maps[e].layerGroupConfig;
            }),
            !1,
            "backupLayers"
          );
        },
        backupLayerById: ({ mapId: e, layerId: i }) => {
          a(
            p((o) => {
              const s = o.maps[e].layerGroupConfig || {}, t = {};
              Object.values(s).map((n) => n.subLayerConfig).filter((n) => Object.keys(n).length !== 0).forEach((n) => {
                const m = Object.keys(n)[0];
                t[m] = n[m];
              });
              const r = { ...s, ...t };
              o.maps[e].backedUpLayerGroupConfig[i] = r[i];
            }),
            !1,
            "backupLayersById"
          );
        },
        restoreLayers: ({ mapId: e }) => {
          a(
            p((i) => {
              const o = Object.assign(
                {},
                i.maps[e].layerGroupConfig,
                i.maps[e].backedUpLayerGroupConfig
              );
              i.maps[e].layerGroupConfig = o;
            }),
            !1,
            "restoreLayers"
          );
        },
        restoreLayersWithCleanup: ({ mapId: e }) => {
          a(
            p((i) => {
              i.maps[e].layerGroupConfig = i.maps[e].backedUpLayerGroupConfig;
            }),
            !1,
            "restoreLayers"
          );
        },
        restoreLayerById: ({ mapId: e, layerId: i }) => {
          a(
            p((o) => {
              var r;
              let s;
              ((r = o == null ? void 0 : o.maps) == null ? void 0 : r[e].backedUpLayerGroupConfig[i]) ? o.maps[e].layerGroupConfig[i] = o.maps[e].backedUpLayerGroupConfig[i] : (Object.entries(o == null ? void 0 : o.maps[e].backedUpLayerGroupConfig).forEach(([m, u]) => {
                Object.keys(u == null ? void 0 : u.subLayerConfig).includes(i) && (s = m);
              }), s && (o.maps[e].layerGroupConfig[s] = o.maps[e].backedUpLayerGroupConfig[s]));
            }),
            !1,
            "restoreLayerById"
          );
        }
      }
    }),
    {
      name: "PLMapboxLayersStore",
      enabled: !!(window && window.__REDUX_DEVTOOLS_EXTENSION__)
    }
  )
);
export {
  Mi as usePLMapboxLayersStore
};
//# sourceMappingURL=index.es12.js.map
